import { Box, HStack, VStack } from '@chakra-ui/react';

const SpecificationView = ({ disabled, name, value }: { disabled: boolean; name: string; value: string }) => (
  <HStack
    sx={{
      fontSize: 'sm',
      alignItems: 'center',
      pl: 4,
      mt: 0,
    }}
    w="full"
  >
    <VStack alignItems="flex-start" gap={0} mt={2}>
      <Box fontSize={12} color="secondaryThemeColour.400" fontWeight="bold">
        {name}
      </Box>
      <Box fontSize={14} sx={disabled ? { color: '#a9a9a9' } : { color: 'secondaryFontColour.500' }}>
        {value}
      </Box>
    </VStack>
  </HStack>
);

export default SpecificationView;
